import { twMerge } from '@/lib/classname/twMerge'
import { Divider } from '@/ui/layouts/divider/Divider'
import { Children, Fragment, type PropsWithChildren } from 'react'

export type ListProps = UiComponentProps &
  PropsWithChildren & {
    withDividers?: boolean
    dividerAtEnd?: boolean
  }

export type ListItemProps = React.PropsWithChildren & {
  ref?: React.RefObject<HTMLDivElement | null>
  className?: string
}

export function CartItemList({
  withDividers = false,
  dividerAtEnd = false,
  className,
  children,
  ...props
}: ListProps) {
  const childrenArray = Children.toArray(children)

  return (
    <div {...props} className={twMerge(className, 'flex flex-col')} data-testid="list" role="list">
      {Children.map(children, (child, i) => (
        // Child can be of any type; it's not possible to know its props.
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={i}>
          {withDividers && i > 0 && <Divider direction="horizontal" variant="line" />}
          {child}
          {dividerAtEnd && i === childrenArray.length - 1 && (
            <Divider direction="horizontal" variant="line" />
          )}
        </Fragment>
      ))}
    </div>
  )
}

function Item({ children, ref, ...props }: ListItemProps): React.ReactElement {
  return (
    <div {...props} data-testid="list-item" role="listitem" ref={ref}>
      {children}
    </div>
  )
}

CartItemList.Item = Item
